module.exports = __webpack_public_path__ + "static/media/p1_s0.c381a7b0.ogg";